import { lazy } from 'react';
import EmptyLayout from 'layouts/EmptyLayout';

const LoginPage = lazy(() =>  import('../pages/User/Login'));

const userRoot = [{
    layout: EmptyLayout,
    routes: [{
        path: "/login",
        element: LoginPage,
        exact: true,
        analytics: { name: ["Login"]},
    }]
}]
export default userRoot;